import * as React from 'react';
import { FixedSizeList as List } from 'react-window';
import PropTypes from 'prop-types';
import AutoSizer from 'react-virtualized-auto-sizer';

import '../searchContainer/SearchTable.scss';

export const AttendeeSearchTable = ({ innerComponents }) => {
  const component = ({ index, style }) => <div style={style}>{innerComponents[index]}</div>;
  return (
    <AutoSizer>
      {({ height, width }) => (
        <List className='folders-search-results'
          itemCount={innerComponents.length}
          itemSize={64}
          height={height}
          width={width}
        >
          {component}
        </List>
      )}
    </AutoSizer>
  );
};

AttendeeSearchTable.propTypes = {
  innerComponents: PropTypes.arrayOf(PropTypes.element),
};
